<template>
  <div>
    <!-- Main router view -->
    <router-view />
    <!-- Chatbot component -->
    <Chatbot v-if="isUserLoggedIn" />
  </div>
</template>

<script>
import { onMounted, onUnmounted, computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import '@/plugins/styles';
import Chatbot from '@/components/chatbot/Chatbot.vue';
export default {
  name: 'App',
  components: {
    Chatbot,
  },
  setup() {
    const store = useStore();
    store.dispatch('setting/setSetting');

    // Computed property to check if the user is logged in
    const isUserLoggedIn = computed(() => store.getters['auth/isLoggedIn']);

    const { appContext } = getCurrentInstance();
    const $logout = appContext.config.globalProperties.$logout;
    const sidebarType = computed(() => store.getters['setting/sidebar_type']);

    // --- Inactivity Logout Setup ---
    const inactivityLimit = 3 * 60 * 60 * 1000; // 3 hour in ms
    let inactivityTimeout = null;

    const resetInactivityTimer = () => {
      if (inactivityTimeout) clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(() => {
        logoutUser();
      }, inactivityLimit);
    };

    const logoutUser = async () => {
      // Dynamically import Firebase auth functions
      $logout(); // Call the global logout function
    };

    const activityHandler = () => {
      resetInactivityTimer();
    };
    // --- End Inactivity Logout Setup ---

    const resizePlugin = () => {
      const sidebarResponsive = document.querySelector(
        '[data-sidebar="responsive"]'
      );
      if (window.innerWidth < 1025) {
        if (sidebarResponsive !== null) {
          if (!sidebarResponsive.classList.contains('sidebar-mini')) {
            sidebarResponsive.classList.add('on-resize');
            store.dispatch('setting/sidebar_type', [
              ...sidebarType.value,
              'sidebar-mini',
            ]);
          }
        }
      } else {
        if (sidebarResponsive !== null) {
          if (
            sidebarResponsive.classList.contains('sidebar-mini') &&
            sidebarResponsive.classList.contains('on-resize')
          ) {
            sidebarResponsive.classList.remove('on-resize');
            store.dispatch(
              'setting/sidebar_type',
              sidebarType.value.filter((item) => item !== 'sidebar-mini')
            );
          }
        }
      }
    };

    onMounted(() => {
      window.addEventListener('resize', resizePlugin);
      setTimeout(() => {
        resizePlugin();
      }, 200);

      // Add event listeners for user activity
      window.addEventListener('mousemove', activityHandler);
      window.addEventListener('keydown', activityHandler);
      window.addEventListener('click', activityHandler);
      window.addEventListener('scroll', activityHandler);

      // Start inactivity timer
      resetInactivityTimer();
    });

    onUnmounted(() => {
      window.removeEventListener('resize', resizePlugin);

      // Remove activity listeners
      window.removeEventListener('mousemove', activityHandler);
      window.removeEventListener('keydown', activityHandler);
      window.removeEventListener('click', activityHandler);
      window.removeEventListener('scroll', activityHandler);

      if (inactivityTimeout) clearTimeout(inactivityTimeout);
    });
    return {
      isUserLoggedIn, // Return the computed property
    };
  },
};
</script>

<style lang="scss">
@import '@/assets/custom-vue/scss/styles.scss';
body {
  font-family: 'Outfit', sans-serif;
}
</style>
